/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import DialogDefault from "@jumbo/components/JumboDialog/components/DialogDefault";
import DialogConfirm from "@jumbo/components/JumboDialog/components/DialogConfirm";

import Stack from "@mui/material/Stack";
import {
  Badge,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import Div from "@jumbo/shared/Div";
import { useDispatch, useSelector } from "react-redux";
import {
  markModuleRead,
  fetchUnreadCount,
} from "app/redux/slice/notificationSlice";
import Loader from "@jumbo/components/Loader";
import { userType } from "app/helpers/userType";
import { useNavigate } from "react-router-dom";
import { officeInvoiceEdit } from "app/routes/constant";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ChangeStatus from "./dialog/change-status";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import {
  deleteInvoice,
  downloadInvoice,
  getInvoiceList,
  updateInvoiceStatus,
} from "app/redux/slice/invoiceSlice";
import { istDateDisplay } from "app/helpers/istDate";
import { useSnackbar } from "notistack";
import { getSupplierList } from "app/redux/slice/supplierSlice";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import FilePreview from "./dialog/file-preview";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";

const Invoice = () => {
  const navigate = useNavigate();

  const { stageAction } = useDisclosure();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { isMA } = userType();

  const invoiceData = useSelector((state) => state?.invoice);
  const supplierData = useSelector((state) => state?.supplier);

  const [searchText, setSearchText] = useState("");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [statusOf, setStatusOf] = useState();
  const [supplierId, setSupplierId] = useState();

  const {
    isOpen: isDelete,
    onClose: closeDelete,
    actionProps: deleteActionProps,
    stageAction: deleteStageAction,
  } = useDisclosure();
  const {
    isOpen: isOpenPaymentStatus,
    onClose: closePaymentStatus,
    actionProps: paymentStatusActionProps,
    stageAction: changeStatusStageAction,
  } = useDisclosure();

  const {
    isOpen: isOpenFilePreview,
    onClose: closeFilePreview,
    actionProps: filePreviewActionProps,
    stageAction: filePreviewStageAction,
  } = useDisclosure();

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "invoice" });

  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission")),
  );

  const [permission, setPermission] = useState({
    createPermission: false,
    updatePermission: false,
    changeStatusPermission: false,
    deletePermission: false,
    downloadPermission: false,
  });
  const getPermission = () => {
    if (isMA) {
      setPermission({
        createPermission: true,
        updatePermission: true,
        changeStatusPermission: true,
        deletePermission: true,
        downloadPermission: true,
      });
    } else {
      let permissionValue = {
        createPermission: false,
        updatePermission: false,
        changeStatusPermission: false,
        deletePermission: false,
        downloadPermission: false,
      };
      const rolePermission = permissionData?.filter((item) => {
        return item?.moduleName?.includes("Invoice") && item;
      });
      rolePermission?.length &&
        rolePermission.forEach(function (num) {
          if (num?.name === "create-invoice") {
            permissionValue.createPermission = true;
          }
          if (num?.name === "delete-invoice") {
            permissionValue.deletePermission = true;
          }
          if (num?.name === "update-invoice") {
            permissionValue.updatePermission = true;
          }
          if (num?.name === "manage-status-invoice") {
            permissionValue.changeStatusPermission = true;
          }
          if (num?.name === "download-invoice") {
            permissionValue.downloadPermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  const handleDocumentDownload = async (row, type = "invoice") => {
    const response = await dispatch(
      downloadInvoice({ id: row?._id, type }),
    ).unwrap();
    if (response?.status === 200) {
      const byteCharacters = atob(response?.data?.data?.base64);
      const byteNumbers = Array.from(byteCharacters)?.map((char) =>
        char.charCodeAt(0),
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: "application/pdf",
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      const documentType = type === "challan" ? "challan" : "invoice";
      const referenceNumber =
        type === "challan"
          ? row?.challanNumber || row?.invoiceNumber
          : row?.invoiceNumber || row?.challanNumber;

      link.href = url;
      link.download = `${documentType}-${referenceNumber || "download"}.pdf`;
      link.click();
      URL.revokeObjectURL(url);
    } else {
      enqueueSnackbar(response.data?.responseMessage, {
        variant: "error",
      });
    }
  };

  const columns = [
    {
      id: "invoiceDate",
      minWidth: 115,
      label: "Date",
      sort: true,
      render: (row) => istDateDisplay(row?.invoiceDate),
    },
    { id: "invoiceNumber", label: "Inv No.", sort: true },
    {
      id: "supplier",
      label: "Belongs To",
      sort: false,
      render: (row) => row?.supplier?.user?.name,
    },
    {
      id: "vendor",
      label: "Vendor",
      render: (row) => row?.supplier?.name,
    },
    {
      id: "PO",
      label: "Del.Status",
      render: (row) => row?.PO?.deliveryType,
    },
    {
      id: "paymentStatus",
      label: "Status",
      sort: true,
      render: (row) =>
        row?.paymentStatus?.[0]?.toUpperCase() + row?.paymentStatus?.slice(1),
    },
    // { id: "dispatchStatus", label: "D. Status", sort: true },
    { id: "challanNumber", label: "Challan No.", sort: true },
    { id: "markaNumber", label: "Marka No", sort: true },
    // { id: "invoiceAmount", label: "Amount", sort: true },
    {
      id: "actions",
      label: "Actions",
      minWidth: 300,
      align: "center",
      render: (row) => (
        <>
          <IconButton
            disabled={!permission.updatePermission}
            onClick={() => {
              stageAction(row);
              navigate(officeInvoiceEdit(row._id));
            }}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            disabled={!permission.changeStatusPermission}
            onClick={() => {
              setStatusOf("payment");
              changeStatusStageAction(row);
            }}
          >
            <CurrencyRupeeIcon />
          </IconButton>
          <Tooltip title="Download Invoice">
            <span>
              <IconButton
                disabled={!permission.downloadPermission}
                onClick={() => handleDocumentDownload(row, "invoice")}
              >
                <FileDownloadIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Download Challan">
            <span>
              <IconButton
                disabled={!permission.downloadPermission}
                onClick={() => handleDocumentDownload(row, "challan")}
              >
                <DescriptionOutlinedIcon />
              </IconButton>
            </span>
          </Tooltip>
          <IconButton
            disabled={!permission.deletePermission}
            onClick={() => {
              deleteStageAction(row);
            }}
          >
            <DeleteIcon color={"error"} />
          </IconButton>
          <Tooltip
            title={
              row?.paymentProofCount
                ? `Files - ${row.paymentProofCount} payment proof(s) from App`
                : "Files"
            }
          >
            <IconButton
              onClick={() => {
                filePreviewStageAction(row);
              }}
            >
              {/* Count of payment proofs the vendor uploaded from the App, so
                  Admin can see at a glance which invoices have one. */}
              <Badge
                badgeContent={row?.paymentProofCount || 0}
                color="error"
                max={99}
              >
                <FolderOpenIcon />
              </Badge>
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const handleSubmit = async (data) => {
    if (statusOf === "payment") {
      const formData = new FormData();
      if (data?.markaNumber) formData.append("markaNumber", data?.markaNumber);
      formData.append(
        "paymentStatus",
        `${data?.paymentStatus ? "paid" : "unpaid"}`,
      );
      data?.files?.forEach((file) => {
        formData.append("paymentStatusImage", file);
      });
      const response = await dispatch(
        updateInvoiceStatus({ id: data?.invoiceId, data: formData }),
      ).unwrap();
      if (response.status === 200) {
        enqueueSnackbar(response.data?.responseMessage, {
          variant: "success",
        });
        getData();
        closePaymentStatus();
      } else {
        enqueueSnackbar(response.data?.responseMessage, {
          variant: "error",
        });
      }
      closePaymentStatus();
    }
  };

  const DeleteInvoice = () => {
    closeDelete();
    dispatch(deleteInvoice(deleteActionProps?._id))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
          closeDelete();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  const getData = () => {
    localStorage.setItem("invoice-search", searchText.trim());
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
      paymentStatus: "unpaid",
      ...(supplierId && { supplierId: supplierId._id }),
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getInvoiceList(value));
    // Mark as read whenever list is fetched
    dispatch(markModuleRead("Invoice")).then(() => {
      dispatch(fetchUnreadCount("Invoice"));
    });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0, 0);
      getData();
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };

  useEffect(() => {
    getPermission();
    dispatch(getSupplierList({ sort: 1, field: "name", type: "Office" }));
  }, []);

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  return (
    <>
      {invoiceData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => setSearchText("")}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <JumboAutoComplete
                      options={supplierData?.list || []}
                      label="Vendor"
                      size="small"
                      getOptionLabel={(option) => option?.name}
                      name={`supplierId`}
                      value={supplierId}
                      onChange={(evt, value) => setSupplierId(value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Invoice List
                </Typography>
                {/* {permission.createPermission && (
                  <LoadingButton
                    onClick={() => {
                      navigate(OFFICE_INVOICE_ADD);
                    }}
                    type="submit"
                    variant="contained"
                  >
                    Add Invoice
                  </LoadingButton>
                )} */}
              </Stack>
              <Table
                columns={columns}
                rows={invoiceData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={invoiceData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
          <DialogConfirm
            isOpen={isDelete}
            onClose={closeDelete}
            title="Are you sure you want to delete the invoice?"
            onConfirm={DeleteInvoice}
            btnLabels={{ cancel: "Cancel", confirm: "Delete" }}
          />
          {permission.createPermission && (
            <DialogDefault
              open={isOpenPaymentStatus}
              onClose={closePaymentStatus}
              content={
                <ChangeStatus
                  value={paymentStatusActionProps}
                  onClose={closePaymentStatus}
                  handleSubmit={handleSubmit}
                  statusOf={statusOf}
                />
              }
              title={
                statusOf === "payment"
                  ? "Change Payment Status"
                  : "Change Dispatch Status"
              }
              fullWidth={false}
              maxWidth={"xs"}
              actions={<></>}
            />
          )}
          <DialogDefault
            open={isOpenFilePreview}
            onClose={closeFilePreview}
            content={
              <FilePreview
                value={filePreviewActionProps}
                onClose={closeFilePreview}
                handleSubmit={handleSubmit}
              />
            }
            title={"Files"}
            fullWidth={false}
            maxWidth={"lg"}
            actions={<></>}
          />
        </>
      )}
    </>
  );
};

export default Invoice;
